
class FormRecovery extends HTMLElement {
  constructor() {
    super();
    this.submitBtn = this.querySelector('button[type="submit"]');
    this.email = this.querySelector('[name="email"]');
    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('.form__message.success');
    this.errorMessage = this.querySelector('.form__message.error');
    this.url = window.appDomain + '/customer/recovery';
    this.emailEmpty = 'メールアドレスを入力してください';
    this.emailInvalid = '不正なメールアドレスです。(例: sample@sample.com)';
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.email.addEventListener('change', this.validateEmailHandler.bind(this));
    this.email.addEventListener('blur', this.validateEmailHandler.bind(this));
    this.email.addEventListener('keyup', this.validateEmailHandler.bind(this));
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  loading(enable) {
    if (enable) {
      this.submitBtn.classList.add('loading');
      this.submitBtn.querySelector('.loading__spinner').classList.remove('hidden');
      this.submitBtn.setAttribute('disabled', true);
    } else {
      this.submitBtn.classList.remove('loading');
      this.submitBtn.querySelector('.loading__spinner').classList.add('hidden');
      this.submitBtn.removeAttribute('disabled');
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const formData = this.getFormData();
    if (this.validateForm()) {
      this.loading(true);
      fetch(this.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            this.showError('', false);
            this.showSuccess(result.message, true);
          } else {
            this.showSuccess('', false);
            this.showError(result.message, true);
          }
        })
        .catch(error => {
          this.showSuccess('', false);
          this.showError(error.message, true);
        })
        .finally(() => {
          this.loading(false);
        });
    }
  }
  getFormData() {
    let formData = {};
    for (let [key, value] of new FormData(this.form)) {
      const match = key.match(/(\w+)\[(\w*)\]/);
      if (match) {
        const [_, parentKey, childKey] = match;
        if (!formData[parentKey]) formData[parentKey] = {};
        formData[parentKey][childKey] = value;
      } else {
        if (!formData[key]) {
          formData[key] = value;
        } else if (Array.isArray(formData[key])) {
          formData[key].push(value);
        } else if (typeof formData[key] === 'string') {
          formData[key] = [formData[key]]
          formData[key].push(value);
        } else {
          formData[key] = value;
        }
      }
    }
    return formData;
  }

  validateEmailHandler(e) {
    let email = this.email.value.trim();
    if (email === '') {
      this.showError(this.emailEmpty, true);
      this.submitBtn.setAttribute('disabled', true);
      return false;
    }
    const validateEmail = validator.isEmail(email)
    if (validateEmail) {
      this.showError('', false);
      this.submitBtn.removeAttribute('disabled');
      return true;
    }
    this.showError(this.emailInvalid, true);
    this.submitBtn.setAttribute('disabled', true);
    return false;
  }

  validateForm() {
    const validateEmailResult = this.validateEmailHandler();
    if (!validateEmailResult) {

    } else {
      this.submitBtn.removeAttribute('disabled');
    }
    return validateEmailResult;
  }

  showError(message, show) {
    this.successMessage.classList.add('hidden');
    this.errorMessage.classList.add('hidden');
    if (show) {
      this.errorMessage.querySelector('.recovery-message').innerHTML = message;
      this.errorMessage.classList.remove('hidden');
    }
  }

  showSuccess(message, show) {
    this.successMessage.classList.add('hidden');
    this.errorMessage.classList.add('hidden');
    if (show) {
      this.successMessage.querySelector('.recovery-message').innerHTML = message;
      this.successMessage.classList.remove('hidden');
    }
  }

}

customElements.define('form-recovery', FormRecovery);
